import apiClient from "./interceptor"

export const sendOtp = async (email) => {
    try {
        const response = await apiClient.post(`v1/common/mr/send-otp`, {
            email: email
        })
        return response;
    } catch (err) {
        console.log(err);
        return err;
    }
}

export const verifyOtp = async (email,otp) => {
    try {
        const response = await apiClient.post(`v1/common/mr/verify-otp`, {
            email: email,
            otp:otp,
        })
        return response;
    } catch (err) {
        console.log(err);
        return err;
    }
}